import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const avatarVariants = cva(
  "inline-flex shrink-0 select-none items-center justify-center rounded-full font-heading font-semibold",
  {
    variants: {
      size: { sm: "h-8 w-8 text-xs", md: "h-10 w-10 text-sm", lg: "h-12 w-12 text-base" },
      tone: { default: "bg-secondary-subtle text-secondary-subtle-fg", inverse: "bg-secondary-hover text-fg-inverse" },
    },
    defaultVariants: { size: "md", tone: "default" },
  },
);

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const first = parts[0]?.[0] ?? "";
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? "") : "";
  return (first + last).toUpperCase();
}

/** Initials avatar. Decorative: the name is always shown next to it or in the label. */
export function Avatar({ name, className, ...variants }: { name: string; className?: string } & VariantProps<typeof avatarVariants>) {
  return (
    <span aria-hidden="true" className={cn(avatarVariants(variants), className)}>
      {initials(name)}
    </span>
  );
}
